export default __webpack_public_path__ + "static/media/eco.7192658a.png";